// START IMPORTS
import { getAndNormalizeFirstRecordSearch } from '@ltvco/refresh-lib/utils';
import { useAccount } from '@ltvco/refresh-lib/v1';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useState, useEffect } from 'react';
// END IMPORTS

// START HELPER_FUNCTIONS
export const useFirstRecordSearch = () => {
  const isInFirstPDFVariation = useFeatureIsOn('feature-pdf-upsell');

  const [firstRecordSearchData] = useState(() =>
    getAndNormalizeFirstRecordSearch()
  );

  const { data: account } = useAccount(true);

  const hadFirstSearch = !!firstRecordSearchData;
  const [showFirstTimePDFModal, setFirstTimePDFModal] = useState(false);

  useEffect(() => {
    if (!account) {
      return;
    }

    if (hadFirstSearch) {
      const isNoncompliantUser =
        account?.account?.user_info?.noncompliant === true;

      setFirstTimePDFModal(
        isInFirstPDFVariation &&
          !account?.account?.subscription_info?.subscription_features
            ?.pdf_access &&
          !isNoncompliantUser
      );
    }
  }, [account]);

  return {
    firstRecordSearchData,
    showFirstTimePDFModal,
  };
};
// END HELPER_FUNCTIONS
